import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ListStateProps } from "../../types/listState";

export interface ListStateState {
  lists: Record<string, ListStateProps>;
}

const initialState: ListStateState = {
  lists: {},
};

const emptyListState: ListStateProps = {};

export const listStateSlice = createSlice({
  name: "listState",
  initialState,
  reducers: {
    saveListState: (
      state,
      action: PayloadAction<{ key: string; value: ListStateProps }>
    ) => {
      state.lists[action.payload.key] = {
        ...state.lists[action.payload.key],
        ...action.payload.value,
      };
    },
    resetListPages: (state, action: PayloadAction<string>) => {
      Object.keys(state.lists).forEach((key) => {
        if (key === action.payload || key.startsWith(action.payload + ":")) {
          state.lists[key].page = 1;
        }
      });
    },
    clearListStates: (state) => {
      state.lists = {};
    },
  },
});

export const { saveListState, resetListPages, clearListStates } =
  listStateSlice.actions;

export const getListState = (state: RootState, key: string) =>
  state.listState.lists[key] || emptyListState;

export default listStateSlice.reducer;
